module.exports = __webpack_public_path__ + "main/assets/public/social-icons/envelope.d8bccf4ec2a2f95a.svg";